@if (isUpdating()) {
  <ui-spinner></ui-spinner>
}

<ui-accordion>
  <ng-template headline="{{ this.status() }}" uiAccordionPanel>
    <div class="tools">
      <ui-page-debugger></ui-page-debugger>
      <ui-auth-debugger></ui-auth-debugger>
    </div>
  </ng-template>
</ui-accordion>
